<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2 class="mt-5 mb-6">{{$t('sub_salary_component')}}</h2>
      </v-col>
      <v-col md="3" class="text-right mt-5" v-if="gcPayslipEnabled && gcPayslipTypeEnabled">
        <v-btn color="primary" dark class="mb-2" @click="openUploadPayslipDialog()">{{$t('upload_payslip')}}</v-btn>
      </v-col>
    </v-row>

    <v-card>
      <v-tabs
        background-color="white"
        color="primary"
        left
        @change="changeActiveTab($event)"
        v-model="tab"
      >
        <v-tab>{{$t('sub_salary_component')}}</v-tab>
        <v-tab>{{$t('position_allowance')}}</v-tab>
        <v-tab>{{$t('employee_salary')}}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container fluid v-if="tabActive == 0">
            <config-component></config-component>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid v-if="tabActive == 1">
            <position-allowance></position-allowance>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid v-if="tabActive == 2">
            <salary-setting></salary-setting>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-model="uploadPayslipDialog" persistent max-width="500px">
      <v-form v-model="validPayslip" ref="formDataPayslip">
        <v-card class="pt-3 mb-2">
          <v-card-title>
            <span class="headline ml-2">{{$t('download_template')}}</span>
          </v-card-title>
          <v-card-text class="text-center">
            <v-btn dark color="primary" @click="downloadTemplate">{{$t('download')}}</v-btn>
          </v-card-text>
        </v-card>
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{$t('upload_payslip')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    v-model="uploadData.file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    :label="$t('select_file')"
                    :rules="rules"
                    required
                  ></v-file-input>
                  <v-progress-linear v-show="uploadData.loading" :value="uploadData.proggress"></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="uploadData.loading"
                color="primary"
                @click="uploadFile()"
                :disabled="!validPayslip"
              >{{$t('save')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import readXlsxFile from 'read-excel-file';
import ConfigComponent from './component/ConfigComponent.vue';
import SalarySetting from './component/SalarySetting.vue';
import PositionAllowance from './component/PositionAllowance.vue'

export default {
  name: "payroll",
  data() {
    return {
      tab: 0,
      baseUrl: this.$store.state.baseUrl,
      tabActive: 0,
      validPayslip: false,
      uploadPayslipDialog: false,
      uploadData: {
        file: null,
        loading: false,
        progress: 0
      },
      rules: [(v) => !!v || this.$i18n.t('required')],
    };
  },
  methods: {
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    close() {
      this.uploadPayslipDialog = false
    },
    openUploadPayslipDialog() {
      this.uploadData = {
        file: null,
        loading: false
      }
      this.uploadPayslipDialog = true
    },
    async downloadTemplate() {
      const url = `${this.baseUrl}/v1/payroll/fujiseat/downloadtemplate`
      const result = await axios.get(url).catch(() => { return null })
      if (result) if (result.data) window.open(result.data.data, '_blank')
    },
    async uploadFile() {
      try {
        this.uploadData.loading = true
        const url = `${this.baseUrl}/v1/payroll/fujiseat/uploadpayroll`
        const data = await readXlsxFile(this.uploadData.file)
        const result = await axios.post(url, { data }, {
          onUploadProgress: (e) => {
            this.uploadData.progress = Math.round(e.loaded / e.total * 100)
          }
        })
        if (result) if (result.data) if (result.data.code == 200) {
          this.showMessage('success', result.data.message)
          this.uploadPayslipDialog = false
        } else {
          this.showMessage('warning', result.data.message)
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        this.showMessage('error', 'Gagal Terupload')
      }
      this.uploadData.loading = false
    },
    changeActiveTab(e) {
      this.tabActive = e
    }
  },
  created() { },
  computed: {
    gcPayslipEnabled() {
      return this.$store.getters.gcGetData('feature_payslip', 'is_enabled')
    },
    gcPayslipTypeEnabled() {
      return this.$store.getters.gcGetData('feature_payslip', 'type')
    },
  },
  components: {
    ConfigComponent,
    SalarySetting,
    PositionAllowance,
  },
  watch: {
    uploadPayslipDialog() {
      if (this.$refs.formDataPayslip) this.$refs.formDataPayslip.resetValidation()
    }
  }
};
</script>